// extracted by mini-css-extract-plugin
module.exports = {"custom_btn":"resetPasswordForm_custom_btn__2CXrN"};